import { createTheme } from "@mui/material";
import * as palette from "framer-motion/m";

export function setupTheme() {
    return createTheme({
        palette: {
            mode: "dark",

            primary: {
                main: "#5FB88A",
                light: "#8FD6B2",
                dark: "#3E8E65",
            },

            secondary: {
                main: "#9ED9B7",
            },

            background: {
                default: "#0B241A",
                paper: "#102F22",
            },

            text: {
                primary: "#F4F7F5",
                secondary: "#B7C9C0",
            },

            divider: "rgb(122,149,130)",
        },
        typography: {
            fontFamily: "Montserrat",
            h4:{
                fontFamily: "DM Sans",
                // Quicksand, Italiana, DM Sans 200 ou 300, Didact Gothic,
                // Darker Grotesque, Cormorant Infant 400, Urbanist 200
                fontWeight: 200,
                color:"white"
            },
            h5:{
                fontFamily: "DM Sans",
                // Quicksand, Italiana, DM Sans 200 ou 300, Didact Gothic,
                // Darker Grotesque, Cormorant Infant 400, Urbanist 200
                fontWeight: 400,
                color:"white"
            },
            h6:{
                fontFamily: "DM Sans",
                // Quicksand, Italiana, DM Sans 200 ou 300, Didact Gothic,
                // Darker Grotesque, Cormorant Infant 400, Urbanist 200
                fontWeight: 400
            },
            body1: {
                fontFamily: "Montserrat",
            }


        },

        components: {
            MuiAlert: {
                styleOverrides: {
                    standardInfo: {
                        backgroundColor: "#133a2a", // vert foncé cohérent avec le fond
                        color: "#ffffff",

                        border: "1px solid #57aa74",

                        "& .MuiAlert-icon": {
                            color: "#57aa74",
                        },
                    },
                },
            },
            /* ================= APP BAR ================= */
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        boxShadow: "none",
                    },
                },
            },

            MuiToolbar: {
                styleOverrides: {
                    root: {
                        justifyContent: "center",
                        position: "relative",
                    },
                },
            },

            /* ================= DRAWER ================= */
            MuiDrawer: {
                styleOverrides: {
                    paper: {
                        width: 250,
                        boxSizing: "border-box",
                    },
                },
            },

            MuiListItemButton: {
                styleOverrides: {
                    root: {
                        textAlign: "center",
                        paddingTop: 16,
                        paddingBottom: 16,

                        "&:hover": {
                            backgroundColor: "var(--green-3)",
                            color: "#fff",
                        },
                    },
                },
            },
        },
    });
}